// export default CreateForm;
import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import FormPreview from "./FormPreview";
import { IoMdAddCircleOutline, IoMdRemoveCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";
import { Checkbox } from "primereact/checkbox";

// Define input types and attributes based on Input.propTypes
const inputAttributes = {
  text: [
    "name",
    "placeholder",
    "required",
    "disabled",
    // "pattern",
    // "sx",
    // "readOnly",
  ],
  boolean: [
    "name",
    "required",
    "disabled",
    // "sx",
  ],
  email: [
    "name",
    "placeholder",
    "required",
    "disabled",
    // "pattern",
    // "sx",
    // "readOnly",
  ],
  number: [
    "name",
    "placeholder",
    "required",
    "disabled",
    "minimumValue",
    "maximumValue",
    // "sx",
    // "readOnly",
  ],
  password: [
    "name",
    "placeholder",
    "required",
    "disabled",
    "maxlength",
    "minlength",
    // "sx",
    // "readOnly",
  ],
  date: [
    "name", 
    "required",
    "disabled", 
    "min", 
    "max", 
    // "sx", "readOnly"
  ],
  time: ["name", "required", "disabled", "min", "max", 
    // "sx", "readOnly"
  ],
  dropdown: ["name", "required", "options"],
  multiselect: ["name", "required", "disabled", "options"],
};
const inputAttributes4Nutration = {
  text: [
    "name",
    "placeholder",
    "required",
    "disabled",
    // "pattern",
    // "sx",
    // "readOnly",
  ],
  boolean: [
    "name",
    "required",
    "disabled",
    // "sx",
  ],
  number: [
    "name",
    "placeholder",
    "required",
    "disabled",
    "minimumValue",
    "maximumValue",
    // "sx",
    // "readOnly",
  ],
  dropdown: ["name", "required", "options"],
  multiselect: ["name", "required", "disabled", "options"],
};



const defaultProps = {
  type: "text",
  placeholder: "",
  value: "",
  required: false,
  disabled: false,
  className: "",
  minimumValue: undefined,
  maximumValue: undefined,
  sx: {},
  readOnly: false,
};

const CreateForm = ({values, onCreateForm,inputType4="dynamicFields" }) => {
  const [ fields, setFields] = useState(values.length?values:[
    {
      label: "",
      type: "text", // default type
      attributes: {},
    },
  ]);

  const [payload, setPayload] = useState(null);

  const addField = () => {
    const {label,type,attributes}= fields[fields.length-1]
    const requiredFields = {label,type,attributes};
    const missingFields = Object.keys(requiredFields).filter(
      (field) => !requiredFields[field] || requiredFields[field] === "undefined"
    );
  
    if (missingFields.length > 0) {      
      toast.warn(`Missing required field: ${missingFields.join(", ")}`)
    }else{

      setFields([
        ...fields,
        {
          label: "",
          type: "text", // default type
          attributes: {},
        },
      ]);
    }
  };

  const updateField = (index, key, value) => {
    const newFields = [...fields];
    newFields[index][key] = value;
    setFields(newFields);
    onCreateForm && onCreateForm(newFields);
  };

  const updateAttribute = (index, attribute, value) => {
    const newFields = [...fields];
    newFields[index].attributes[attribute] = value;
    setFields(newFields);
    onCreateForm && onCreateForm(newFields);
  };

  const renderAttributeInput = (index, attr) => {
    const value = fields[index].attributes[attr] || "";

    // Render different inputs based on attribute type
    if (["required", "disabled", "readOnly"].includes(attr)) {
      return (
        <Checkbox      
        value={value}
        onClick={(e) => {          
          updateAttribute(index, attr, !value)
        }}
        checked={!!value}
        className="bg-[--color--2] cursor-pointer rounded-full"
        ></Checkbox>
      );
    }

    if (
      [
        "minimumValue",
        "maximumValue",
        "min",
        "max",
        "maxlength",
        "minlength",
      ].includes(attr)
    ) {
      return (
        <input
          type="number"
          value={value}
          onChange={(e) => updateAttribute(index, attr, Number(e.target.value))}
          placeholder={`Enter ${attr}`}
          className="w-full p-2 bg-[--bg-color]  border border-[--bg-tbl-header] rounded"
        />
      );
    }

    if (attr === "sx") {
      return (
        <textarea
          value={JSON.stringify(value, null, 2)}
          onChange={(e) =>
            updateAttribute(index, attr, JSON.parse(e.target.value || "{}"))
          }
          placeholder="Enter inline styles as JSON"
          className="w-full p-2 bg-[--bg-color]  border border-[--bg-tbl-header] rounded"
        />
      );
    }

    return (
      <input
        type="text"
        value={value}
        onChange={(e) => updateAttribute(index, attr, e.target.value)}
        placeholder={`Enter ${attr}`}
        className="w-full p-2 bg-[--bg-color]  border border-[--bg-tbl-header] rounded"
      />
    );
  };

  const saveForm = () => {
    const formConfig = {
      fields: fields.map((field) => ({
        ...field,
        attributes: {
          ...defaultProps,
          ...field.attributes, // Merge attributes with default props
        },
      })),
    };
    console.log("Form Config:", formConfig);
    setPayload(formConfig);
    onCreateForm && onCreateForm(formConfig);
  };
  const removeField = () => {
    if(fields.length===1){
      toast.warn(`Last field can't be Removed!`)
    }
    else{
      setFields((p)=>{    
          p.pop()
          onCreateForm && onCreateForm(p);
          return p
       
      })
    }
  };

  return (
    <div>
      {/* <div className="max-w-4xl mx-auto px-6 py-8 bg-gray-100 rounded-lg shadow-md "> */}
      <div>
        <div className="space-y-4">
          {/* {JSON.stringify(fields)} */}
          {fields&&fields.map((field, index) => (
            <div key={index} className="p-4 rounded-lg shadow">
              <h4 className="text-xl font-semibold mb-2">Field {index + 1}</h4>

              <div className="mb-4">
                <label className="block mb-1 font-semibold">Label:</label>
                <input
                  type="text"
                  value={field.label}
                  onChange={(e) => updateField(index, "label", e.target.value)}
                  placeholder="Enter field label"
                  className="w-full p-2 rounded bg-[--bg-color] border border-[--bg-tbl-header]"
                />
              </div>

              <div className="mb-4">
                <label className="block mb-1 font-semibold">Type:</label>
                <select
                  value={field.type}
                  onChange={(e) => updateField(index, "type", e.target.value)}
                  className="w-full p-2 bg-[--bg-color]  border border-[--bg-tbl-header] rounded"
                >
                  {Object.keys(inputType4==='nutritionalFields'?inputAttributes4Nutration:inputAttributes).map((type) => (
                    <option className="bg-[--bg-color]" key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="space-y-2">
                {inputAttributes[field.type].map((attr) => (
                  <div key={attr} className="mb-2">
                    <label className="block mb-1 font-semibold">{attr}:</label>
                    {renderAttributeInput(index, attr)}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-evenly items-center gap-1 mt-4">
            <button
                   onClick={(e)=>{
                    e.preventDefault()
                    addField()
                  }}
                  // className="mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                  className="btn p-0 w-[2rem] h-[2rem] flex justify-center items-center rounded-full"
                >
                <IoMdAddCircleOutline style={{fontSize:'1.5rem'}}/>
                </button>

                <button
                  onClick={(e)=>{
                    e.preventDefault()
                    removeField()
                  }}
                  // className="mt-4 bg-green-500 text-white p-2 rounded hover:bg-green-600 ml-4"
                  className="btn p-0 w-[2rem] h-[2rem] flex justify-center items-center rounded-full"
                >
                  <IoMdRemoveCircleOutline  style={{fontSize:'1.5rem'}} />
                </button>
        </div>
      </div>
      <div>
        <FormPreview formConfig={payload} />
      </div>
    </div>
  );
};

export default CreateForm;
